
import { Asset } from "./asset";
import { Gateway } from "./gateway";
import { Org } from "./org";
import { Site } from "./site";

export class DerivedAsset {
	id: number;
	title: string;
	value: number;
	assetType_id: number;
	assetTypeTitle: string;
	orgShortTitle: string;
	siteTitle: string;
	gatewayTitle: string;
	org: Org;
	gateway: Gateway;
	site: Site;
	parent: Asset;
	children: Asset[];
	childrenCount: number;
	childrenAsString: string;
	maximumChildren: number;
	minimumChildren: number;
	maximum: number;


	constructor(data?: any) {

		if (typeof data === 'string') {
			switch (data.toLowerCase().trim()) {
				case 'delta t':
					this.assetType_id = 83;
					break;
				case 'percentage':
				case '%':
					this.assetType_id = 84;
					break;
				case 'accumulated daily':
				case 'daily accumulated':
					this.assetType_id = 85;
					break;
				default:
					console.log('unknown type', data);
					return;
			}

			this.buildFromType();

			return;
		}

		if (data?.derivedAsset) {
			this.parent = new Asset(data.derivedAsset);
			this.children = data.sources.map((c: any) => new Asset(c));
		} else {
			this.parent = new Asset(data);
			this.children = data.children.map((c: any) => new Asset(c));
			this.org = new Org({ id: data.orgId, shortTitle: data.orgShortTitle });
			this.gateway = new Gateway({ id: data.gateway_id, title: data.gatewayTitle });
			this.site = new Site({ id: data.siteId, title: data.siteTitle });
		}
		this.value = +this.parent.value;
		this.id = this.parent.id;
		this.title = this.parent.title;
		this.childrenCount = this.children.length;
		this.childrenAsString = this.children.map(c => c.title).join(', ');
		this.siteTitle = this.site?.title;
		this.orgShortTitle = this.org?.shortTitle;
		this.gatewayTitle = this.gateway?.title;
		this.assetType_id = this.parent.assetType_id;

		this.buildFromType();
	}

	buildFromType() {
		this.minimumChildren = 1;
		switch (this.assetType_id) {
			case 83:
				this.assetTypeTitle = 'Delta T';
				this.maximumChildren = 2;
				this.minimumChildren = 2;
				break;
			case 84:
				this.assetTypeTitle = 'Percentage';
				this.maximumChildren = 1;
				break;
			case 85:
				this.assetTypeTitle = 'Accumulated Daily';
				this.maximumChildren = 1;
				break;
			default:
				console.log('unknown derived type id', this.assetType_id);
				return;
		}
		this.children = [];
		this.childrenCount = 0;
		this.childrenAsString = '';
	}

	serialise() {
		return {
			id: this.parent?.id ?? null,
			children: this.children?.map(c => c.id) ?? [],
			assetType_id: this.assetType_id,
			maximum: this.maximum,
			title: this.title,
			gateway_id: this.gateway?.id ?? null
		}
	}

	display() {
		return this.parent.title;
	}
}
